<div class="relative text-platform flex justify-center">
  <div class="page-container">
    <div class="relative text-platform">
      <div class="h-32 md:h-40"></div>
      <div class="text-5xl sm:text[4rem] lg:text-[5rem] font-bold mb-12">Hey {{ givenName() }}!</div>
      <div class="mb-5">
        @if (state.isLoading()) {
          <ticketing-loading-indicator />
        } @else {
          @if (state.draws(); as draws) {
            <div class="font-semibold text-xl lg:text-3xl mb-4">Zur Registrierung geöffnete Losungen</div>
            @if (draws.submission.length > 0) {
              <div class="grid lg:grid-cols-2 gap-4">
                @for (draw of draws.submission; track draw.id) {
                  <pos-draw-item [draw]="draw" />
                }
              </div>
            } @else {
              <div class="opacity-50">Momentan gibt es keine aktiven Losungen.</div>
            }
            <div class="h-16"></div>

            <div class="font-semibold text-xl lg:text-3xl mb-4">Zur Ticketausgabe geöffnete Losungen</div>
            @if (draws.drawn.length > 0) {
              <div class="grid lg:grid-cols-2 gap-4">
                @for (draw of draws.drawn; track draw.id) {
                  <pos-draw-item [draw]="draw" />
                }
              </div>
            } @else {
              <div class="opacity-50">Momentan gibt es keine aktiven Losungen.</div>
            }
          }
        }
      </div>
    </div>
  </div>
</div>
